import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { gstinValidationSchema } from "../../../utilities/schema";

const GstInvoice = ({
  open,
  onClose,
  gstInvoiceDetails,
  setGstInvoiceDetails,
}) => {
  const [values, setValues] = useState({
    gstin: "",
    business_name: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /* Prefill data when editing */
  useEffect(() => {
    if (open) {
      setValues({
        gstin: gstInvoiceDetails?.gstin || "",
        business_name: gstInvoiceDetails?.business_name || "",
      });
      setErrors({});
    }
  }, [open, gstInvoiceDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: name === "gstin" ? value.toUpperCase() : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      /* Yup validation */
      await gstinValidationSchema.validate(values, {
        abortEarly: false,
      });

      setGstInvoiceDetails(values);
      onClose();
    } catch (err) {
      const formErrors = {};
      if (err.inner) {
        err.inner.forEach((e) => {
          formErrors[e.path] = e.message;
        });
      }
      setErrors(formErrors);
    } finally {
      setLoading(false);
    }
  };

  const isDisabled =
    !values.gstin || !values.business_name || Object.keys(errors).length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          pb={1.5}
          borderBottom="1px solid #D3D3D3"
        >
          <Typography fontSize={16} fontWeight={600}>
            GST Invoice
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* GSTIN */}
        <Typography fontSize={14} mb={0.5}>
          GSTIN
        </Typography>
        <TextField
          fullWidth
          size="small"
          name="gstin"
          placeholder="22AAAAA0000A1Z5"
          value={values.gstin}
          onChange={handleChange}
          error={Boolean(errors.gstin)}
          helperText={errors.gstin}
        />

        {/* Business Name */}
        <Typography fontSize={14} mt={2} mb={0.5}>
          Business Name
        </Typography>
        <TextField
          fullWidth
          size="small"
          name="business_name"
          value={values.business_name}
          onChange={handleChange}
          error={Boolean(errors.business_name)}
          helperText={errors.business_name}
        />

        {/* Info */}
        <Box
          display="flex"
        //   alignItems="center"
        //   justifyContent="center"
          gap={1}
          mt={2}
        >
          <InfoOutlinedIcon fontSize="small" color="primary" />
          <Typography fontSize={12} fontWeight={600}>
            Incorrect GSTIN details will lead to order cancellation
          </Typography>
        </Box>

        {/* Submit */}
        <Button
          fullWidth
          onClick={handleSubmit}
          disabled={isDisabled || loading}
          variant="contained"
          sx={{
            mt: 3,
            height: 48,
            backgroundColor: isDisabled ? "#A7A7A7" : "#FF272F",
            "&:hover": {
              backgroundColor: isDisabled ? "#A7A7A7" : "#E52027",
            },
          }}
        >
          {loading && (
            <CircularProgress size={20} sx={{ color: "#fff", mr: 1 }} />
          )}
          Confirm and Save
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GstInvoice;
